import { z } from 'zod';
import { Email, optional, PersonName, ZaPhone } from './primitives.js';
/**
 * The contact and partner forms on the marketing site.
 *
 * These are the only forms an unauthenticated visitor can post, so they
 * collect the least that lets us reply: a name, a way to answer and the
 * message. No address, no account (POPIA: collect only what the screen
 * needs).
 */
export const ENQUIRY_KINDS = ['CONTACT', 'PARTNER', 'MEMBER'];
export const EnquiryInput = z.object({
    kind: z.enum(ENQUIRY_KINDS),
    name: PersonName,
    email: Email,
    /** Optional: an email address is enough to reply to. */
    phone: optional(ZaPhone),
    message: z
        .string()
        .trim()
        .min(10, 'Tell us a little more, so we can help.')
        .max(4000, 'Keep this under 4000 characters.'),
    /**
     * Consent to be contacted about this enquiry. Separate and un-ticked
     * (POPIA), and not marketing consent: answering a question is not
     * permission to send offers.
     */
    consent: z.literal(true, 'Tick this so we may reply to you.'),
});
//# sourceMappingURL=enquiries.js.map